import {
  Menu,
  MenuItem,
  FormControlLabel,
  Divider,
  Grid2,
  IconButton,
  Tooltip,
  Checkbox
} from "@mui/material";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import { FilterAltOff } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useLoading } from "../../../../components/Loading";
import { useSnackbar } from "../../../../context/popup";
import { fetchData } from "../../../../services";


const GeneralBranchFilterDialog = ({ anchorEl, open, onClose, filterData, setFilterData, onApply }) => {

    const { setCircleLoading } = useLoading();
    const { showSnackbar } = useSnackbar();
    const [bankOptions, setBankOptions] = useState([]);

    //dropdown apis
    useEffect(() => {
        if(!open){
            return;
        }
        //dropdown apis for form
        const fetchDropdowns = async () => {
        setCircleLoading(true);
        try {
        const [bankResponse] = await Promise.all([
            fetchData(`/reference/general/bank?dropdown=true&isActive=true`)
        ]);
    
            if (bankResponse?.success) {
            setBankOptions(
                bankResponse.data?.items?.map((item) => ({
                    value: item.id,
                    label: item.name,
                })) || []
            );
            }
        } catch (error) {
            console.error("Error fetching dropdown data:", error);
            showSnackbar("Error fetching filter data","error");
        } finally {
            setCircleLoading(false);
        }
        };
    
        fetchDropdowns();
    }, [open]);

    const handleChange = ({ target: { name, value } }) => {
        setFilterData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const onClearFilters = () => {
        setFilterData({
            isActive: "",
            policyId: "",
            productId: ""
        });
    };


  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      sx={{backgroundColor: "rgba(0, 0, 0, 0.3)",}}
      PaperProps={{
          elevation: 3,
          sx: {
            width: 240,
            padding: 1.5,
          },
      }}
    >
        <MaterialBox
        sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        }}
        >
            {/* Title */}
            <MaterialTypography variant="body2" fontWeight="bold">
                Branch Filter
            </MaterialTypography>

            {/* Clear Button */}
            <Tooltip title="Clear Filter" disableInteractive>
                <IconButton
                    size="small"
                    onClick={onClearFilters}
                    sx={{ color: "#ce0707ff" }}
                >
                    <FilterAltOff />
                </IconButton>
            </Tooltip>
        </MaterialBox>


      {/* Content */}
        <MaterialBox ml={1} sx={{maxHeight: 300, overflowY: "auto"}}>
            <Grid2 container spacing={1}>
                <Grid2 size={{ xs: 12 }}>
                    <MaterialBox>
                        <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                        >
                            Active Status
                        </MaterialTypography>
                    </MaterialBox>
                    <MaterialBox ml={1}>                  
                        <MenuItem
                        onClick={() =>
                            handleChange({
                            target: { name: "isActive", value: true },
                            })
                        }>
                            <FormControlLabel
                            sx={{
                                m: 0,   
                                '& .MuiFormControlLabel-label': { fontSize: '0.8rem' },
                            }}
                            control={
                                <Checkbox
                                size="small"
                                checked={filterData.isActive === true}          
                                />
                            }
                            label="Active"
                            />
                        </MenuItem>
                        <MenuItem
                        onClick={() =>
                            handleChange({
                            target: { name: "isActive", value: false },
                            })
                        }>
                            <FormControlLabel
                            sx={{
                                m: 0,
                                '& .MuiFormControlLabel-label': { fontSize: '0.8rem' },
                            }}
                            control={
                                <Checkbox
                                size="small"
                                checked={filterData.isActive === false}                   
                                />
                            }
                            label="Inactive"
                            />
                        </MenuItem>
                    </MaterialBox>
                </Grid2>
                <Grid2 size={{ xs: 12 }}>
                    <MaterialBox>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        >
                        Bank
                        </MaterialTypography>
                    </MaterialBox>

                    <MaterialBox ml={1}>

                        {/* Dynamic State List */}
                        {bankOptions?.map((state) => (
                        <MenuItem
                            key={state.value}
                            onClick={() =>
                            handleChange({
                                target: { name: "bankId", value: state.value },
                            })
                            }
                        >
                            <FormControlLabel
                            sx={{
                                m: 0,
                                "& .MuiFormControlLabel-label": { fontSize: "0.8rem" },
                            }}
                            control={
                                <Checkbox
                                size="small"
                                checked={filterData.bankId === state.value}
                                />
                            }
                            label={state.label}
                            />
                        </MenuItem>
                        ))}
                    </MaterialBox>
                </Grid2>
            </Grid2>

        </MaterialBox>

        <Divider />

        {/* Apply button */}
        <MenuItem
        onClick={() => onApply()}
        disableRipple
        sx={{
            padding: "6px 16px", 
            width: "fit-content",
            minWidth: "0px",
            mx: "auto",  
            borderRadius: "6px",
            backgroundColor: "#bcc7e9",
            color: "white",
            display: "flex",
            justifyContent: "center",
            transition: "0.2s ease",

            "&:hover": {
            backgroundColor: "#93a6e8",
            }
        }}
        >
        <MaterialTypography variant="button" fontWeight="bold">
            APPLY FILTER
        </MaterialTypography>
        </MenuItem>
    </Menu>
  );
};

export default GeneralBranchFilterDialog;
